import { logger } from "./logger";
var loggedScripts = new Set();
export function logWebpackBundlePerformanceMetrics() {
    try {
        var resources = window.performance.getEntriesByType("resource");
        var origin = window.location.origin;
        var scriptInfo = [];
        var totalDecodedBodySize = 0;
        var totalTransferSize = 0;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = resources[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var resource = _step.value;
                if (resource.initiatorType !== "script" || !resource.name.startsWith(origin) || loggedScripts.has(resource.name)) {
                    continue;
                }
                loggedScripts.add(resource.name);
                totalDecodedBodySize += resource.decodedBodySize;
                totalTransferSize += resource.transferSize;
                scriptInfo.push({
                    href: resource.name,
                    pathname: new URL(resource.name).pathname,
                    transferSize: resource.transferSize,
                    decodedBodySize: resource.decodedBodySize
                });
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        logger.report("telemetry", "webpackBundle", {
            totalTransferSize: totalTransferSize,
            totalDecodedBodySize: totalDecodedBodySize,
            scriptInfo: scriptInfo
        });
    } catch (e) {
    // All modern browsers support the PerformanceResourceTiming API, but we
    // should fail gracefully when running into those that don't.
    }
}
